import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllUserRoleGroupsQueryVariables, useAllUserRoleGroupsQuery } from "../../graphql"
import { UserRoleGroupsList } from "./UserRoleGroupsList"

export const AllUserRoleGroups: React.FC = () => {
	const [pagination, setPagination] = useState<AllUserRoleGroupsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllUserRoleGroupsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allUserRoleGroups.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allUserRoleGroups ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading groups</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allUserRoleGroups.userRoleGroups && data.allUserRoleGroups.userRoleGroups.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allUserRoleGroups.userRoleGroups.length || 0} group
						{(data.allUserRoleGroups.userRoleGroups.length || 0) > 1 ? "s" : ""}
					</Text>

					<UserRoleGroupsList userRoleGroups={data.allUserRoleGroups.userRoleGroups} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more groups</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any groups.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
